import { QueryType } from "src/types/models";

/**
 * Predicate for "is this sync auto-created by the realtime-traits feature
 * (its segment is the reconciler-managed warehouse-state model)?" Keyed
 * strictly on `query_type = 'realtime_trait_warehouse_state'`.
 *
 * This intentionally does NOT use the broader `isManagedQueryType` /
 * `ManagedQueryTypes` set: Decision Engine, Predictive, Journey, IDR, and CEP
 * managed models keep their own existing edit flows.
 */
export function isManagedSyncSegment(
  segment: { query_type?: string | null } | null | undefined,
): boolean {
  return segment?.query_type === QueryType.RealtimeTraitWarehouseState;
}

export type AIDManagedSegment = {
  flow_message?: {
    decision_engine_flow_id: string;
    decision_engine_message_id: string;
  } | null;
  channel_syncs?: {
    flow_id: string;
  } | null;
};

/**
 * Predicate for "is this sync managed by AI Decisioning?"
 *
 * This mirrors the backend `isDecisionEngineManagedSync` guard.
 */
export function isAIDManagedSegment(
  segment: AIDManagedSegment | null | undefined,
): boolean {
  return Boolean(segment?.flow_message || segment?.channel_syncs);
}

export const AID_MANAGED_SYNC_DELETE_TOOLTIP =
  "This sync cannot be deleted because it is managed by AI Decisioning";

export function getAIDManagedSyncHref(
  segment: AIDManagedSegment | null | undefined,
): string | null {
  if (segment?.flow_message?.decision_engine_message_id) {
    return `/ai/flows/${segment.flow_message.decision_engine_flow_id}/messages/${segment.flow_message.decision_engine_message_id}`;
  }
  if (segment?.channel_syncs?.flow_id) {
    return `/ai/flows/${segment.channel_syncs.flow_id}`;
  }
  return null;
}
